<template>
  <el-select v-model="roleid" :placeholder="placeholder"  filterable clearable style="width:100%;" :disabled="disabled" @change="selectChange">
    <el-option v-for="(item, index) in list" :key="index" :label="item.title" :value="item.roleid">
    </el-option>
  </el-select>
</template>

<script>
import { roleGetallApi } from '@/api/fam/famMemberApi'

export default {
	name: "RoleSelector",

	props: {
		value: {
			type: [Number, String],
			default: ''
		},

		placeholder: {
			type: String,
			default: '角色权限'
		},

		disabled: {
			type: Boolean,
			default: false
		},
	},

	data () {
		return {
			list: []
		}
	},

	computed: {
		roleid: {
			get () {
				return this.value ? this.value : null
			},
			set (val) {
				this.$emit('input', val ? val : null)
			}
		}
	},

	watch: {
	},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData() {
      roleGetallApi().then(res => {
        if (!res.errno) {
          this.list = res.data.list
          this.$emit('getRoleList', this.list)
        } else {
          this.$message.error(res.message)
        }
      })
    },

		selectChange (val) {
			const list = this.list.map(v => v.roleid)
			const index = list.indexOf(val)
			const item = this.list[index]
			this.$emit('change', item)
		}
	}
}
</script>